import { useQuery } from "react-query";
import { AxiosError } from "axios";
import http from "infra/http";
import { FiltroExportacaoContabil } from "features/exportacao-contabil/typings";

function useDownloadExportacaoContabilExcel(params: FiltroExportacaoContabil) {
  return useQuery<ArrayBuffer, AxiosError>(
    [`/v1/contabilidade/exportacao-contabil`, params],
    async () => {
      const { data } = await http.post<ArrayBuffer>(
        "/v1/contabilidade/exportacao-contabil",
        params,
        {
          responseType: "arraybuffer",
        }
      );

      console.log("excel", data);
      return data;
    },
    {
      enabled: false,
    }
  );
}

export default useDownloadExportacaoContabilExcel;
